"use client"
import React, {useState, useEffect} from 'react'
import useIntersectionObserver from "@react-hook/intersection-observer";
import {useAxios} from "hooks/useAxios";
import {useRouter, useSearchParams} from "next/navigation";
import ContentListItem from "../ContentListItem/ContentListItem";
import {CgSpinner} from "react-icons/cg";
import {useTekstClient} from "hooks/useTekstClient";
import useGebruiker from "hooks/useGebruiker";
import {useFormTitle} from "../../../../hooks/useFormTitle";

const SearchingSkeleton = () => (
    <div className="space-y-4 py-4">
        {[...Array(5)].map((_, i) => (
            <div key={i} className="animate-pulse flex flex-col gap-2 p-4 border border-kleur-licht-grijs3 rounded">
                <div className="h-4 bg-kleur-licht-grijs3 rounded w-3/4"/>
                <div className="h-3 bg-kleur-licht-grijs3 rounded w-1/2 opacity-60"/>
                <div className="h-3 bg-kleur-licht-grijs3 rounded w-full opacity-40"/>
            </div>
        ))}
    </div>
);

export const ContentLijst = ({kennisItems, page, setSize, isLoadingMore, isLoading, isReachingEnd, mutate}) => {
    const searchParams = useSearchParams()
    const weergaveCompact = searchParams.get('cpt') === "1"
    const {ingelogdeGebruiker} = useGebruiker()
    const [ref, setRef] = useState()
    const {isIntersecting} = useIntersectionObserver(ref)
    const {tekst} = useTekstClient()
    const router = useRouter()
    const {get} = useAxios()
    const {formTitle} = useFormTitle()

    const showInfiniteLoader = !isReachingEnd

    useEffect(() => {
        if (!isIntersecting || isLoadingMore || isReachingEnd) return
        setSize(prev => prev + 1);
    }, [isIntersecting, isLoadingMore, isReachingEnd, setSize])

    const handleBookmark = (id) => {
        get(`wiki/item/bookmark/${id}`)
            .then(() => {
                mutate()
            }).catch()
            .finally();
    }


    const handleOpenInNieuwVenter = (item) => {
        window.open(`/mijn-mkg/support/kenniscentrum/id/${item.id}/${formTitle(item.content_gepubliceerd?.titel)}`, '_blank');
    }

    const handleBewerken = (item) => {
        if (item.wiki_vorm_id === 19) {
            router.push(`/mijn-mkg/beheer/content-management/content/mail/${item.id}`)
        } else if (item.wiki_vorm_id === 10) {
            router.push(`/mijn-mkg/beheer/content-management/content/media/${item.id}`)
        } else {
            router.push(`/mijn-mkg/beheer/content-management/content/${item.id}`)
        }
    }

    if (isLoading) {
        return <ul className="col-span-9 list-none"><SearchingSkeleton/></ul>;
    }

    return <ul className={`col-span-9 list-none`}>

        {kennisItems.map((page, pageIndex) => {
            return page.data?.map((item) => {
                return <ContentListItem weergaveCompact={weergaveCompact} ingelogdeGebruiker={ingelogdeGebruiker}
                                        key={`${pageIndex}-${item.id}`}
                                        item={item}
                                        handleBookmark={handleBookmark} handleBewerken={handleBewerken}
                                        handleOpenInNieuwVenter={handleOpenInNieuwVenter}
                                        searchParams={searchParams}/>
            })
        })}

        {showInfiniteLoader && <li className={`flex flex-col items-center justify-center gap-2`} ref={setRef}>
            {<CgSpinner className={`animate-spin text-4xl text-kleur-donker-blauw`}/>}

            <div className={`animate-bounce ml-2`}>{tekst(`algemeen:laden`)}</div>
        </li>}


    </ul>

}
